const DESTINATION = 'G-0VE8J7ZVZ2';
const EVENTS = new Set(['wcf_section_view', 'wcf_section_click', 'wcf_option_select', 'wcf_size_guide_open', 'wcf_customization_open', 'wcf_amazon_click', 'wcf_add_to_cart_error']);
const KEYS = ['wcf_section', 'wcf_section_name', 'wcf_action', 'wcf_target', 'wcf_option', 'wcf_product_id', 'wcf_variant_id', 'wcf_error'];
const EVENT_LABELS = {wcf_section_view:'板块被看到',wcf_section_click:'板块内点击',wcf_option_select:'选择商品规格',wcf_size_guide_open:'打开尺码指南',wcf_customization_open:'打开定制入口',wcf_amazon_click:'点击前往亚马逊',wcf_add_to_cart_error:'出现加购错误提示'};
const PAGE_LABELS = {index:'首页',product:'商品详情页',collection:'商品分类页',list_collections:'分类目录页',cart:'购物车页',search:'搜索结果页',page:'内容页',blog:'博客列表页',article:'文章页','404':'页面未找到',password:'店铺密码页',gift_card:'礼品卡页'};
const ACTION_LABELS = {add_to_cart_button:'点击加入购物车按钮',checkout_button:'点击去结账按钮',quantity_plus:'增加购买数量',quantity_minus:'减少购买数量',accordion_toggle:'展开或收起内容',link:'点击链接',button:'点击按钮',color:'选择颜色',size:'选择尺码',length:'选择裤长',variant:'选择商品规格',size_guide:'打开尺码指南',customization:'打开定制入口',customization_close:'收起定制信息',amazon_exit:'点击前往亚马逊',hero_custom:'首页点击定制入口',hero_women:'首页点击女款入口',hero_men:'首页点击男款入口'};
const SECTION_LABELS = {header:'顶部导航区','announcement-bar':'顶部公告条',footer:'页脚信息区',CartDrawer:'侧边购物车','cart-drawer':'侧边购物车','product-grid':'商品列表与筛选区','related-products':'相关推荐商品区',cozyfit_breadcrumbs_BMa4TG:'商品分类路径导航','1774404646958a4d9c':'顾客评价区',newsletter_rR6b9f:'邮件订阅区',global:'全站公共区域','main-cart-items':'购物车商品列表','main-cart-footer':'购物车金额与结账区'};
const TITLE_LABELS = {'You may also like':'相关推荐商品区','Subscribe to our emails':'邮件订阅区','Filter:':'商品列表与筛选区','Your cart is empty':'侧边购物车','Have an account?':'账户登录提示区','COZYFIT Comfort & COZY SCRUBS Care':'品牌介绍区'};
const ERROR_LABELS = {size_required:'尚未选择尺码',color_required:'尚未选择颜色',availability:'商品缺货或不可购买',validation:'商品选项校验未通过'};
const label = (map,key) => Object.hasOwn(map,key) ? map[key] : '';

function clean(value) {
  const text = String(value ?? '').replace(/\s+/g, ' ').trim();
  if (!text || /@|(?:%40)|(?:https?:\/\/)|[?&](?:email|phone|token|key)=/i.test(text)) return '';
  return text.slice(0, 100);
}

export function safeTarget(href, origin) {
  try {
    const url = new URL(href, origin);
    if (!/^https?:$/.test(url.protocol)) return '';
    if (/(^|\.)amazon\.com$/.test(url.hostname)) return 'amazon.com';
    if (url.origin !== origin) return url.hostname;
    if (/^\/(account|checkouts?|orders)(\/|$)/.test(url.pathname)) return url.pathname.split('/')[1];
    return clean(decodeURIComponent(url.pathname));
  } catch { return ''; }
}

export function sectionKey(id) {
  return clean(String(id || '').replace(/^shopify-section-/, '').replace(/^.*__/, '')) || 'global';
}

export function exposureQualifies(r, width, height) {
  if (!r || r.width <= 0 || r.height <= 0 || width <= 0 || height <= 0) return false;
  const w = Math.max(0, Math.min(r.right, width) - Math.max(r.left, 0));
  const h = Math.max(0, Math.min(r.bottom, height) - Math.max(r.top, 0));
  return w * h >= Math.min(r.width, width) * Math.min(r.height, height) * 0.5;
}

export function payloadFor(config, data, eventName = '') {
  const payload = {send_to: DESTINATION, wcf_page_type: label(PAGE_LABELS,config.pageType) || '其他页面', wcf_environment: config.preview ? 'preview' : 'production', transport_type: 'beacon'};
  if (config.preview) payload.debug_mode = true;
  for (const key of KEYS) {
    const value = clean(data[key]);
    if (value) payload[key] = value;
  }
  const section = payload.wcf_section || '';
  const title = payload.wcf_section_name || '';
  let sectionName = label(SECTION_LABELS,section) || label(TITLE_LABELS,title);
  if (!sectionName && /^Your cart(?:\s|$)/.test(title)) sectionName = '侧边购物车';
  if (!sectionName && section === 'banner') sectionName = config.pageType === 'collection' ? '分类页顶部介绍区' : '页面横幅区';
  if (!sectionName && section === 'main' && config.pageType === 'product') sectionName = title ? `商品详情：${title}` : '商品详情区';
  if (!sectionName && /^cozyfit_breadcrumbs/.test(section)) sectionName = '商品分类路径导航';
  if (!sectionName && /^newsletter/.test(section)) sectionName = '邮件订阅区';
  if (!sectionName && /^related.products/.test(section)) sectionName = '相关推荐商品区';
  if (sectionName) payload.wcf_section_name = clean(sectionName);
  const action = payload.wcf_action || '';
  const eventLabel = label(EVENT_LABELS,eventName);
  if (eventLabel) payload.wcf_event_label = eventLabel;
  const translatedAction = label(ACTION_LABELS,action) || (/^hero_/.test(action) ? '首页首屏入口点击' : '');
  if (translatedAction || (!action && eventLabel)) payload.wcf_action = translatedAction || eventLabel;
  if (payload.wcf_error) payload.wcf_error = label(ERROR_LABELS,payload.wcf_error) || '其他加购错误';
  return payload;
}

export function createSender(win, config) {
  return (name, data = {}) => {
    if (!EVENTS.has(name)) return false;
    try {
      if (win.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof win.gtag !== 'function') return false;
      const payload = payloadFor(config, data, name);
      try {
        const page = new URL(win.location.href);
        payload.page_location = page.origin + page.pathname;
        const referrer = new URL(win.document?.referrer || page.origin);
        payload.page_referrer = referrer.origin === page.origin ? referrer.origin + referrer.pathname : referrer.origin + '/';
        if (!win.document?.referrer) payload.page_referrer = '';
      } catch {}
      win.gtag('event', name, payload);
      return true;
    } catch { return false; }
  };
}

export function createExposure({schedule, cancel, qualifies, send}) {
  const pending = new Map();
  const seen = new Set();
  return {pending, seen, update(key, visible, data) {
    if (!visible) {
      if (pending.has(key)) cancel(pending.get(key));
      pending.delete(key);
      return;
    }
    if (seen.has(key) || pending.has(key)) return;
    pending.set(key, schedule(() => {
      pending.delete(key);
      if (qualifies(key) && send(data)) seen.add(key);
    }, 1000));
  }, clear() {
    for (const timer of pending.values()) cancel(timer);
    pending.clear();
  }};
}

export function install(win, doc) {
  if (win.__cozyfitAnalytics || win.Shopify?.designMode) return;
  const node = doc.getElementById('cozyfit-analytics-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (/customer|account|checkout|order/.test(config.pageType || '')) return;
  config.preview = win.Shopify?.theme?.role !== 'main';
  const send = createSender(win, config);
  const sections = new Map();
  let trackedErrors = new WeakMap();
  const listeners = [];
  let lastAddAttempt = 0;
  let stopped = false;
  let scanTimer;
  let retryTimer;
  let attempts = 0;
  let frame;
  const on = (object, name, callback, options) => {
    object.addEventListener(name, callback, options);
    listeners.push(() => object.removeEventListener(name, callback, options));
  };
  const allowed = () => {
    try { return win.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof win.gtag === 'function'; }
    catch { return false; }
  };
  const visible = (element) => doc.visibilityState === 'visible' && element?.isConnected && allowed()
    && win.getComputedStyle(element).visibility !== 'hidden'
    && exposureQualifies(element.getBoundingClientRect(), win.innerWidth, win.innerHeight);
  const sectionData = (element) => {
    const section = element?.closest?.('cart-drawer, .shopify-section, header, footer');
    const id = sectionKey(section?.id || section?.tagName?.toLowerCase());
    return {
      wcf_section: id,
      wcf_section_name: config.sections?.[id] || clean(section?.querySelector?.('h2,h3')?.textContent) || id,
    };
  };
  const productData = (element) => {
    const info = element?.closest?.('product-info');
    const variant = info?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    return {wcf_product_id: info?.dataset.productId || config.productId || '', wcf_variant_id: /^\d+$/.test(variant || '') ? variant : ''};
  };
  const exposure = createExposure({
    schedule: (fn, ms) => win.setTimeout(fn, ms), cancel: id => win.clearTimeout(id),
    qualifies: key => visible(sections.get(key)), send: data => send('wcf_section_view', data),
  });
  const checkVisibility = () => {
    frame = undefined;
    for (const [id, element] of sections) exposure.update(id, visible(element), sectionData(element));
  };
  const scheduleVisibility = () => {
    if (!frame && !stopped) frame = win.requestAnimationFrame(checkVisibility);
  };
  const observer = typeof win.IntersectionObserver === 'function'
    ? new win.IntersectionObserver(scheduleVisibility, {threshold: Array.from({length: 21}, (_, i) => i / 20)}) : null;
  const scan = () => {
    if (stopped) return;
    for (const [id, el] of sections) {
      if (!el.isConnected) { observer?.unobserve(el); sections.delete(id); exposure.update(id, false, {}); }
    }
    for (const el of doc.querySelectorAll('main .shopify-section, .shopify-section-group-header-group, .shopify-section-group-footer-group, cart-drawer')) {
      const key = sectionData(el).wcf_section;
      if (sections.get(key) === el) continue;
      const previous = sections.get(key);
      if (previous) observer?.unobserve(previous);
      sections.set(key, el); observer?.observe(el);
    }
    if (Date.now() - lastAddAttempt < 10000) {
      for (const el of doc.querySelectorAll('.product-form__error-message')) {
        const text = el.textContent.trim();
        if (!text || el.closest('[hidden]') || trackedErrors.get(el) === text) continue;
        const reason = /choose.*size/i.test(text) ? 'size_required' : /choose.*color/i.test(text) ? 'color_required' : /sold out|stock|available/i.test(text) ? 'availability' : 'validation';
        if (send('wcf_add_to_cart_error', {...sectionData(el), ...productData(el), wcf_error: reason})) trackedErrors.set(el, text);
      }
    }
    scheduleVisibility();
  };
  const scheduleScan = () => {
    win.clearTimeout(scanTimer);
    scanTimer = win.setTimeout(scan, 200);
  };
  on(doc, 'click', event => {
    const target = event.target?.closest?.('a,button,summary,[data-wcf-entry],[data-wcf-color-swatch],.sizeChart,.wcf-measurements-summary-toggle');
    if (!target || target.closest('#admin-bar-iframe, #preview-bar-iframe, [data-cozyfit-ignore]')) return;
    const href = target.getAttribute('href') || '';
    const data = {...sectionData(target), ...productData(target)};
    data.wcf_target = href ? safeTarget(href, win.location.origin) : '';
    data.wcf_action = target.matches('[name="add"]') ? 'add_to_cart_button'
      : target.matches('[name="checkout"],a[href*="/checkout"]') ? 'checkout_button'
      : target.matches('[name="plus"],[name="minus"]') ? `quantity_${target.name}`
      : target.matches('summary') ? 'accordion_toggle' : href ? 'link' : 'button';
    if (target.matches('[name="add"]')) { lastAddAttempt = Date.now(); trackedErrors = new WeakMap(); win.setTimeout(scan, 300); }
    if (target.dataset.wcfEntry) data.wcf_action = `hero_${clean(target.dataset.wcfEntry)}`;
    if (target.matches('[data-wcf-color-swatch]')) {
      data.wcf_action = 'color';
      data.wcf_option = clean(target.dataset.wcfColorName || target.getAttribute('aria-label'));
      data.wcf_target = safeTarget(target.dataset.wcfVariantUrl || '', win.location.origin);
      send('wcf_option_select', data);
    }
    if (target.matches('.sizeChart,[data-size-guide]')) {
      data.wcf_action = 'size_guide'; send('wcf_size_guide_open', data);
    }
    if (target.matches('.wcf-measurements-summary-toggle') || /tailor-made|custom-sized/.test(href) || target.dataset.wcfEntry === 'custom') {
      const closing = target.matches('.wcf-measurements-summary-toggle') && target.closest('.wcf-measurements-summary-open');
      data.wcf_action = closing ? 'customization_close' : 'customization';
      if (!closing) send('wcf_customization_open', data);
    }
    if (data.wcf_target === 'amazon.com') {
      data.wcf_action = 'amazon_exit'; send('wcf_amazon_click', data);
    }
    send('wcf_section_click', data);
  }, true);
  on(doc, 'change', event => {
    const target = event.target;
    if (!target?.matches?.('variant-selects input[type="radio"],variant-selects select')) return;
    const selected = target.tagName === 'SELECT' ? target.selectedOptions?.[0] : target;
    const name = selected?.dataset.optionName || target.dataset.optionName || target.closest('fieldset')?.querySelector('legend')?.textContent || '';
    const type = /color|colour/i.test(name) ? 'color' : /size/i.test(name) ? 'size' : /length/i.test(name) ? 'length' : 'variant';
    send('wcf_option_select', {...sectionData(target), wcf_product_id: productData(target).wcf_product_id, wcf_action: type, wcf_option: clean(target.value)});
  }, true);
  on(doc, 'visibilitychange', () => { exposure.clear(); scheduleVisibility(); });
  on(doc, 'visitorConsentCollected', () => { exposure.clear(); scan(); });
  on(doc, 'shopify:section:load', scan);
  on(win, 'scroll', scheduleVisibility, {passive: true});
  on(win, 'resize', scheduleVisibility, {passive: true});
  const mutations = new win.MutationObserver(scheduleScan);
  mutations.observe(doc.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['hidden']});
  const ready = () => {
    if (stopped) return;
    scan();
    if (!allowed() && ++attempts < 60) retryTimer = win.setTimeout(ready, 500);
  };
  if (!win.Shopify?.customerPrivacy && typeof win.Shopify?.loadFeatures === 'function') {
    win.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], () => { if (!stopped) scan(); });
  }
  win.__cozyfitAnalytics = {
    version: '1.1.0',
    status: () => ({destination: DESTINATION, environment: config.preview ? 'preview' : 'production', consentAllowed: allowed(), sections: sections.size, viewed: [...exposure.seen]}),
    stop: () => {
      stopped = true; exposure.clear(); mutations.disconnect(); observer?.disconnect();
      win.clearTimeout(scanTimer); win.clearTimeout(retryTimer); if (frame) win.cancelAnimationFrame(frame);
      listeners.forEach(remove => remove());
    },
  };
  ready();
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') install(window, document);
